import apiUrl from "./api-url";

const apiMethod = {
  fetchApi: async function (fullUrl, bodyData, token, method) {
    var resp = null;
    resp = await fetch(fullUrl, {
      method: method,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json;charset=utf-8",
        Authorization: "Bearer " + token,
      },
      body:
        bodyData != null && bodyData != "" ? JSON.stringify(bodyData) : null,
    })
      .then((data) => {
        return data;
      })
      .then((response) => {
        if (response.status == 401) {
          return {
            status: 401,
            messages: ["خطای دسترسی به سرویس"],
            exception: "",
          };
        } else {
          return response.json();
        }
      })
      .catch((error) => {
        return {
          status: 500,
          messages: ["خطا در " + fullUrl],
          exception: error,
        };
      });
    return resp;
  },
  postMultipartData: async function (fullUrl, bodyData, token) {
    var resp = null;
    resp = await fetch(fullUrl, {
      method: "POST",
      headers: {
        Authorization: "Bearer " + token,
      },
      body: bodyData,
    })
      .then((data) => {
        return data;
      })
      .then((response) => {
        if (response.status == 401) {
          return {
            status: 401,
            messages: ["خطای دسترسی به سرویس"],
            exception: "",
          };
        } else {
          return response.json();
        }
      })
      .catch((error) => {
        return {
          status: 500,
          messages: ["خطا در " + fullUrl],
          exception: error,
        };
      });
    return resp;
  },
  getApi: async function (fullUrl, token) {
    return await this.fetchApi(fullUrl, null, token, "GET");
  },
  postApi: async function (fullUrl, bodyData, token) {
    return await this.fetchApi(fullUrl, bodyData, token, "POST");
  },
  deleteApi: async function (fullUrl, token) {
    return await this.fetchApi(fullUrl, null, token, "DELETE");
  },
  putApi: async function (fullUrl, bodyData, token) {
    return await this.fetchApi(fullUrl, bodyData, token, "PUT");
  },
  getTokenValue: function () {
    if (localStorage.userInfo === undefined || localStorage.userInfo === null) {
      return "";
    }
    try {
      let userInfo = JSON.parse(localStorage.userInfo);
      return userInfo.token;
    } catch (error) {
      return "";
    }
  },
  //Api methopds
  getToken: async function (request) {
    return await this.postApi(apiUrl.getToken, request, "");
  },
  registerUser: async function (request) {
    return await this.postApi(apiUrl.registerUser, request, "");
  },
  confirmOtp: async function (phoneNumber, otpCode) {
    return await this.getApi(
      apiUrl.confirmOtp + "/?phoneNumber=" + phoneNumber + "&code=" + otpCode,
      ""
    );
  },
  getUserProfile: async function () {
    return await this.getApi(apiUrl.getUserProfile, this.getTokenValue());
  },
  getUserInfo: async function () {
    return await this.getApi(apiUrl.getUserInfo, this.getTokenValue());
  },
  updateProfile: async function (request) {
    return await this.postApi(
      apiUrl.updateProfile,
      request,
      this.getTokenValue()
    );
  },
  getUserBranches: async function () {
    return await this.getApi(apiUrl.getUserBranches, this.getTokenValue());
  },
  createBranch: async function (request) {
    return await this.postApi(
      apiUrl.createBranch,
      request,
      this.getTokenValue()
    );
  },
  getBranchInfo: async function (id) {
    return await this.getApi(
      apiUrl.getBranchInfo + "?branchId=" + id,
      this.getTokenValue()
    );
  },
  getRestaurantBranches: async function (id) {
    return await this.getApi(
      apiUrl.getRestaurantBranches + "?restaurantId=" + id,
      this.getTokenValue()
    );
  },
  getRestaurantInfo: async function (id) {
    return await this.getApi(
      apiUrl.getRestaurantInfo + "?Id=" + id,
      this.getTokenValue()
    );
  },
  getBranchStatus: async function (branchId) {
    return await this.getApi(
      apiUrl.getBranchStatus + "?branchId=" + branchId,
      this.getTokenValue()
    );
  },
  deleteBranch: async function (id) {
    return await this.deleteApi(apiUrl.deleteBranch + id, this.getTokenValue());
  },
  getCities: async function (ProvinceId, title, size, part) {
    return await this.getApi(
      apiUrl.getCities +
        "?ProvinceId=" +
        ProvinceId +
        "&title=" +
        title +
        "&size=" +
        size +
        "&part=" +
        part
    );
  },
  getProvinces: async function (CountryId, size, part, title) {
    return await this.getApi(
      apiUrl.getProvinces +
        "?CountryId=" +
        CountryId +
        "&size=" +
        size +
        "&part=" +
        part +
        "&title=" +
        title
    );
  },
  uploadFile: async function (request) {
    return await this.postMultipartData(
      apiUrl.uploadFile,
      request,
      this.getTokenValue()
    );
  },
  deleteFile: async function (request) {
    return await this.postApi(apiUrl.deleteFile, request, this.getTokenValue());
  },
  getUserRestaurants: async function () {
    return await this.getApi(apiUrl.getUserRestaurants, this.getTokenValue());
  },
  getAllUnits: async function (branchId) {
    return await this.getApi(
      apiUrl.getAllUnits + "?branchId=" + branchId,
      this.getTokenValue()
    );
  },
  getUnits: async function (branchId, size, part, title) {
    return await this.getApi(
      apiUrl.getUnits +
        "?branchId=" +
        branchId +
        "&size=" +
        size +
        "&part=" +
        part +
        "&title=" +
        title,
      this.getTokenValue()
    );
  },
  getUnitInfo: async function (id) {
    return await this.getApi(
      apiUrl.getUnitInfo + "?Id=" + id,
      this.getTokenValue()
    );
  },
  createUnit: async function (request) {
    return await this.postApi(apiUrl.createUnit, request, this.getTokenValue());
  },
  removeUnit: async function (id) {
    return await this.deleteApi(apiUrl.removeUnit + id, this.getTokenValue());
  },
  getPagers: async function (branchId, size, part, title) {
    return await this.getApi(
      apiUrl.getPagers +
        "?branchId=" +
        branchId +
        "&size=" +
        size +
        "&part=" +
        part +
        "&title=" +
        title,
      this.getTokenValue()
    );
  },
  getPagerInfo: async function (id) {
    return await this.getApi(
      apiUrl.getPagerInfo + "?Id=" + id,
      this.getTokenValue()
    );
  },
  createPager: async function (request) {
    return await this.postApi(
      apiUrl.createPager,
      request,
      this.getTokenValue()
    );
  },
  removePager: async function (id) {
    return await this.deleteApi(apiUrl.removePager + id, this.getTokenValue());
  },
  enablePager: async function (id) {
    return await this.putApi(
      apiUrl.enablePager + id,
      null,
      this.getTokenValue()
    );
  },
  getPrinters: async function (branchId, title, size, part) {
    return await this.getApi(
      apiUrl.getPrinters +
        "?branchId=" +
        branchId +
        "&title=" +
        title +
        "&size=" +
        size +
        "&part=" +
        part,
      this.getTokenValue()
    );
  },
  getPrinterInfo: async function (id) {
    return await this.getApi(
      apiUrl.getPrinterInfo + "?Id=" + id,
      this.getTokenValue()
    );
  },
  createPrinter: async function (request) {
    return await this.postApi(
      apiUrl.createPrinter,
      request,
      this.getTokenValue()
    );
  },
  removePrinter: async function (id) {
    return await this.deleteApi(
      apiUrl.removePrinter + id,
      this.getTokenValue()
    );
  },
  getDiningTables: async function (branchId, unitId, size, part, title) {
    return await this.getApi(
      apiUrl.getDiningTables +
        "?branchId=" +
        branchId +
        "&unitId=" +
        unitId +
        "&size=" +
        size +
        "&part=" +
        part +
        "&title=" +
        title,
      this.getTokenValue()
    );
  },
  getDiningTable: async function (id) {
    return await this.getApi(
      apiUrl.getDiningTable + "?Id=" + id,
      this.getTokenValue()
    );
  },
  createDiningTable: async function (request) {
    return await this.postApi(
      apiUrl.createDiningTable,
      request,
      this.getTokenValue()
    );
  },
  removeDiningTable: async function (id) {
    return await this.deleteApi(
      apiUrl.removeDiningTable + id,
      this.getTokenValue()
    );
  },
  getEmployeeTypes: async function () {
    return await this.getApi(apiUrl.getEmployeeTypes, this.getTokenValue());
  },
  getEmployees: async function (
    branchId,
    size,
    part,
    mobile,
    firstName,
    lastName,
    code,
    type
  ) {
    return await this.getApi(
      apiUrl.getEmployees +
        "?branchId=" +
        branchId +
        "&size=" +
        size +
        "&part=" +
        part +
        "&mobile=" +
        mobile +
        "&firstName=" +
        firstName +
        "&lastName=" +
        lastName +
        "&code=" +
        code +
        "&type=" +
        type,
      this.getTokenValue()
    );
  },
  getWaiters: async function (branchId, mobile, firstName, lastName, code) {
    return await this.getApi(
      apiUrl.getWaiters +
        "?branchId=" +
        branchId +
        "&mobile=" +
        mobile +
        "&firstName=" +
        firstName +
        "&lastName=" +
        lastName +
        "&code=" +
        code,
      this.getTokenValue()
    );
  },
  getEmployeeInfo: async function (id) {
    return await this.getApi(
      apiUrl.getEmployeeInfo + "?Id=" + id,
      this.getTokenValue()
    );
  },
  createEmployee: async function (request) {
    return await this.postApi(
      apiUrl.createEmployee,
      request,
      this.getTokenValue()
    );
  },
  changeActivationEmployee: async function (request) {
    return await this.postApi(
      apiUrl.changeActivationEmployee,
      request,
      this.getTokenValue()
    );
  },
  removeEmployee: async function (id) {
    return await this.deleteApi(
      apiUrl.removeEmployee + id,
      this.getTokenValue()
    );
  },
  getCashDesks: async function (branchId, size, part, title, unitId) {
    return await this.getApi(
      apiUrl.getCashDesks +
        "?branchId=" +
        branchId +
        "&size=" +
        size +
        "&part=" +
        part +
        "&title=" +
        title +
        "&unitId=" +
        unitId,
      this.getTokenValue()
    );
  },
  getCashDeskInfo: async function (id) {
    return await this.getApi(
      apiUrl.getCashDeskInfo + "?Id=" + id,
      this.getTokenValue()
    );
  },
  createCashdesk: async function (request) {
    return await this.postApi(
      apiUrl.createCashdesk,
      request,
      this.getTokenValue()
    );
  },
  removeCashDesk: async function (id) {
    return await this.deleteApi(
      apiUrl.removeCashDesk + id,
      this.getTokenValue()
    );
  },
  getDeskActivities: async function (deskId, size, part) {
    return await this.getApi(
      apiUrl.getDeskActivities +
        "?deskId=" +
        deskId +
        "&size=" +
        size +
        "&part=" +
        part,
      this.getTokenValue()
    );
  },
  getDeskActivityInfo: async function (id) {
    return await this.getApi(
      apiUrl.getDeskActivityInfo + "?Id=" + id,
      this.getTokenValue()
    );
  },
  createDeskActivity: async function (request) {
    return await this.postApi(
      apiUrl.createDeskActivity,
      request,
      this.getTokenValue()
    );
  },
  openCashDesk: async function (id) {
    return await this.putApi(
      apiUrl.openCashDesk + id,
      null,
      this.getTokenValue()
    );
  },
  closeCashDesk: async function (request) {
    return await this.postApi(
      apiUrl.closeCashDesk,
      request,
      this.getTokenValue()
    );
  },
  getCashDeskReport: async function (cashDeskId) {
    return await this.getApi(
      apiUrl.getCashDeskReport + "?cashDeskId=" + cashDeskId,
      this.getTokenValue()
    );
  },
  getCashdeskCredits: async function (request) {
    return await this.postApi(
      apiUrl.getCashdeskCredits,
      request,
      this.getTokenValue()
    );
  },
  getCashDeskUsers: async function (
    deskId,
    size,
    part,
    firstName,
    lastName,
    mobile,
    empCode
  ) {
    return await this.getApi(
      apiUrl.getCashDeskUsers +
        "?deskId=" +
        deskId +
        "&size=" +
        size +
        "&part=" +
        part +
        "&firstName=" +
        firstName +
        "&lastName=" +
        lastName +
        "&mobile=" +
        mobile +
        "&empCode=" +
        empCode,
      this.getTokenValue()
    );
  },
  createCashDeskUser: async function (request) {
    return await this.postApi(
      apiUrl.createCashDeskUser,
      request,
      this.getTokenValue()
    );
  },
  removeCashDeskUser: async function (id) {
    return await this.deleteApi(
      apiUrl.removeCashDeskUser + id,
      this.getTokenValue()
    );
  },
  findCahiers: async function (
    branchId,
    deskId,
    size,
    part,
    firstName,
    lastName,
    mobile,
    empCode
  ) {
    return await this.getApi(
      apiUrl.findCahiers +
        "?branchId=" +
        branchId +
        "&deskId=" +
        deskId +
        "&size=" +
        size +
        "&part=" +
        part +
        "&firstName=" +
        firstName +
        "&lastName=" +
        lastName +
        "&mobile=" +
        mobile +
        "&empCode=" +
        empCode,
      this.getTokenValue()
    );
  },
  findCashDeskPrinters: async function (branchId, deskId, size, part, title) {
    return await this.getApi(
      apiUrl.findCashDeskPrinters +
        "?branchId=" +
        branchId +
        "&deskId=" +
        deskId +
        "&size=" +
        size +
        "&part=" +
        part +
        "&title=" +
        title,
      this.getTokenValue()
    );
  },
  getDeskPrinters: async function (deskId, title, size, part) {
    return await this.getApi(
      apiUrl.getDeskPrinters +
        "?deskId=" +
        deskId +
        "&title=" +
        title +
        "&size=" +
        size +
        "&part=" +
        part,
      this.getTokenValue()
    );
  },
  createDeskPrinter: async function (request) {
    return await this.postApi(
      apiUrl.createDeskPrinter,
      request,
      this.getTokenValue()
    );
  },
  removeDeskPrinter: async function (id) {
    return await this.deleteApi(
      apiUrl.removeDeskPrinter + id,
      this.getTokenValue()
    );
  },
  findPosDevices: async function (branchId, deskId, size, part, title) {
    return await this.getApi(
      apiUrl.findPosDevices +
        "?branchId=" +
        branchId +
        "&deskId=" +
        deskId +
        "&size=" +
        size +
        "&part=" +
        part +
        "&title=" +
        title,
      this.getTokenValue()
    );
  },
  getDeskPosDevices: async function (deskId, title, size, part) {
    return await this.getApi(
      apiUrl.getDeskPosDevices +
        "?deskId=" +
        deskId +
        "&title=" +
        title +
        "&size=" +
        size +
        "&part=" +
        part,
      this.getTokenValue()
    );
  },
  createDeskPos: async function (request) {
    return await this.postApi(
      apiUrl.createDeskPos,
      request,
      this.getTokenValue()
    );
  },
  removeDeskPos: async function (id) {
    return await this.deleteApi(
      apiUrl.removeDeskPos + id,
      this.getTokenValue()
    );
  },
  getPoses: async function (branchId, size, part, title, terminalId) {
    return await this.getApi(
      apiUrl.getPoses +
        "?branchId=" +
        branchId +
        "&size=" +
        size +
        "&part=" +
        part +
        "&title=" +
        title +
        "&terminalId=" +
        terminalId,

      this.getTokenValue()
    );
  },
  getPosInfo: async function (id) {
    return await this.getApi(
      apiUrl.getPosInfo + "?Id=" + id,
      this.getTokenValue()
    );
  },
  createPos: async function (request) {
    return await this.postApi(apiUrl.createPos, request, this.getTokenValue());
  },
  removePosDevice: async function (id) {
    return await this.deleteApi(
      apiUrl.removePosDevice + id,
      this.getTokenValue()
    );
  },
  getPosProviders: async function (branchId, size, part, title) {
    return await this.getApi(
      apiUrl.getPosProviders +
        "?branchId=" +
        branchId +
        "&size=" +
        size +
        "&part=" +
        part +
        "&title=" +
        title,
      this.getTokenValue()
    );
  },
  getPosProviderInfo: async function (id) {
    return await this.getApi(
      apiUrl.getPosProviderInfo + "?Id=" + id,
      this.getTokenValue()
    );
  },
  createPosProvider: async function (request) {
    return await this.postApi(
      apiUrl.createPosProvider,
      request,
      this.getTokenValue()
    );
  },
  removePosProvider: async function (id) {
    return await this.deleteApi(
      apiUrl.removePosProvider + id,
      this.getTokenValue()
    );
  },
  initialPosProviders: async function (request) {
    return await this.postApi(
      apiUrl.initialPosProviders,
      request,
      this.getTokenValue()
    );
  },
  getShipmentCosts: async function (branchId, title, size, part) {
    return await this.getApi(
      apiUrl.getShipmentCosts +
        "?branchId=" +
        branchId +
        "&title=" +
        title +
        "&size=" +
        size +
        "&part=" +
        part,
      this.getTokenValue()
    );
  },
  getShipmentCostInfo: async function (id) {
    return await this.getApi(
      apiUrl.getShipmentCostInfo + "?Id=" + id,
      this.getTokenValue()
    );
  },
  createShipmentCost: async function (request) {
    return await this.postApi(
      apiUrl.createShipmentCost,
      request,
      this.getTokenValue()
    );
  },
  removeShipmentCost: async function (id) {
    return await this.deleteApi(
      apiUrl.removeShipmentCost + id,
      this.getTokenValue()
    );
  },
  getShipmentTypes: async function () {
    return await this.getApi(apiUrl.getShipmentTypes, this.getTokenValue());
  },
  getBranchSettings: async function (branchId, title, size, part) {
    return await this.getApi(
      apiUrl.getBranchSettings +
        "?branchId=" +
        branchId +
        "&title=" +
        title +
        "&size=" +
        size +
        "&part=" +
        part,
      this.getTokenValue()
    );
  },
  getBranchSettingInfo: async function (id) {
    return await this.getApi(
      apiUrl.getBranchSettingInfo + "?Id=" + id,
      this.getTokenValue()
    );
  },
  createBranchSetting: async function (request) {
    return await this.postApi(
      apiUrl.createBranchSetting,
      request,
      this.getTokenValue()
    );
  },
  getSettingByName: async function (branchId, keyName) {
    return await this.getApi(
      apiUrl.getSettingByName + "?branchId=" + branchId + "&keyName=" + keyName,
      this.getTokenValue()
    );
  },
  refactorBranchSetting: async function (branchId) {
    return await this.getApi(
      apiUrl.refactorBranchSetting + "?branchId=" + branchId,
      this.getTokenValue()
    );
  },
  getAllDeliveries: async function (branchId) {
    return await this.getApi(
      apiUrl.getAllDeliveries + "?branchId=" + branchId,
      this.getTokenValue()
    );
  },
  getDeliveries: async function (
    branchId,
    size,
    part,
    firstName,
    lastName,
    mobile,
    code
  ) {
    return await this.getApi(
      apiUrl.getDeliveries +
        "?branchId=" +
        branchId +
        "&size=" +
        size +
        "&part=" +
        part +
        "&firstName=" +
        firstName +
        "&lastName=" +
        lastName +
        "&mobile=" +
        mobile +
        "&code=" +
        code,
      this.getTokenValue()
    );
  },
  getDeliveryInvoices: async function (branchId, userId, size, part) {
    return await this.getApi(
      apiUrl.getDeliveryInvoices +
        "?branchId=" +
        branchId +
        "&userId=" +
        userId +
        "&size=" +
        size +
        "&part=" +
        part,
      this.getTokenValue()
    );
  },
  // getUserPos: async function (branchId, userId) {
  //     return await this.getApi(apiUrl.getUserPos + '?branchId=' + branchId + '&userId=' + userId, this.getTokenValue());
  // },
  findPosForDelivery: async function (
    branchId,
    userId,
    size,
    part,
    title,
    code
  ) {
    return await this.getApi(
      apiUrl.findPosForDelivery +
        "?branchId=" +
        branchId +
        "&userId=" +
        userId +
        "&size=" +
        size +
        "&part=" +
        part +
        "&title=" +
        title +
        "&code=" +
        code,
      this.getTokenValue()
    );
  },
  createPosUser: async function (request) {
    return await this.postApi(
      apiUrl.createPosUser,
      request,
      this.getTokenValue()
    );
  },
  removePosUser: async function (id) {
    return await this.deleteApi(
      apiUrl.removePosUser + id,
      this.getTokenValue()
    );
  },
  getPosSummationReport: async function (posId, deskId) {
    return await this.getApi(
      apiUrl.getPosSummationReport + "?posId=" + posId + "&deskId=" + deskId,
      this.getTokenValue()
    );
  },
  getPosReport: async function (posId, startDate, endDate) {
    return await this.getApi(
      apiUrl.getPosReport +
        "?posId=" +
        posId +
        "&startDate=" +
        startDate +
        "&endDate=" +
        endDate,
      this.getTokenValue()
    );
  },
  getUserPos: async function (branchId, userId, title, size, part) {
    return await this.getApi(
      apiUrl.getUserPos +
        "?branchId=" +
        branchId +
        "&userId=" +
        userId +
        "&title=" +
        title +
        "&size=" +
        size +
        "&part=" +
        part,
      this.getTokenValue()
    );
  },
  getMenuCategories: async function (
    branchId,
    parentId,
    size,
    part,
    title,
    saleUnitId,
    enabled
  ) {
    return await this.getApi(
      apiUrl.getMenuCategories +
        "?branchId=" +
        branchId +
        "&parentId=" +
        parentId +
        "&size=" +
        size +
        "&part=" +
        part +
        "&title=" +
        title +
        "&saleUnitId=" +
        saleUnitId +
        "&enabled=" +
        enabled,
      this.getTokenValue()
    );
  },
  getMenuCategoryInfo: async function (id) {
    return await this.getApi(
      apiUrl.getMenuCategoryInfo + "?Id=" + id,
      this.getTokenValue()
    );
  },
  createMenuCategory: async function (request) {
    return await this.postApi(
      apiUrl.createMenuCategory,
      request,
      this.getTokenValue()
    );
  },
  enableMenuCategory: async function (id) {
    return await this.putApi(
      apiUrl.enableMenuCategory + id,
      null,
      this.getTokenValue()
    );
  },
  removeMenuCategory: async function (id) {
    return await this.deleteApi(
      apiUrl.removeMenuCategory + id,
      this.getTokenValue()
    );
  },
  findProductForMenu: async function (branchId, size, part, title, code) {
    return await this.getApi(
      apiUrl.findProductForMenu +
        "?branchId=" +
        branchId +
        "&size=" +
        size +
        "&part=" +
        part +
        "&title=" +
        title +
        "&code=" +
        code,
      this.getTokenValue()
    );
  },
  getMenus: async function (branchId, unitId, categoryId, size, part, title , enabled) {
    return await this.getApi(
      apiUrl.getMenus +
        "?branchId=" +
        branchId +
        "&unitId=" +
        unitId +
        "&categoryId=" +
        categoryId +
        "&size=" +
        size +
        "&part=" +
        part +
        "&title=" +
        title +
        "&enabled=" +
        enabled,
      this.getTokenValue()
    );
  },
  getMenuInfo: async function (menuId) {
    return await this.getApi(
      apiUrl.getMenuInfo + "?menuId=" + menuId,
      this.getTokenValue()
    );
  },
  createMenu: async function (request) {
    return await this.postApi(apiUrl.createMenu, request, this.getTokenValue());
  },
  enableMenu: async function (id) {
    return await this.putApi(
      apiUrl.enableMenu + id,
      null,
      this.getTokenValue()
    );
  },
  removeMenu: async function (id) {
    return await this.deleteApi(apiUrl.removeMenu + id, this.getTokenValue());
  },
  findRolesForEmployee: async function (userId, title) {
    return await this.getApi(
      apiUrl.findRolesForEmployee + "?userId=" + userId + "&title=" + title,
      this.getTokenValue()
    );
  },
  getEmployeeRoles: async function (userId, title) {
    return await this.getApi(
      apiUrl.getEmployeeRoles + "?userId=" + userId + "&title=" + title,
      this.getTokenValue()
    );
  },
  addRoleToEmployee: async function (request) {
    return await this.postApi(
      apiUrl.addRoleToEmployee,
      request,
      this.getTokenValue()
    );
  },
  removeRoleFromEmployee: async function (request) {
    return await this.postApi(
      apiUrl.removeRoleFromEmployee,
      request,
      this.getTokenValue()
    );
  },
  getSnappToken: async function (branchId, unitId) {
    return await this.getApi(
      apiUrl.getSnappToken + "/?branchId=" + branchId + "&unitId=" + unitId,
      this.getTokenValue()
    );
  },
  getSnappCategories: async function (branchId, unitId, size, part, title) {
    return await this.getApi(
      apiUrl.getSnappCategories +
        "/?branchId=" +
        branchId +
        "&unitId=" +
        unitId +
        "&size=" +
        size +
        "&part=" +
        part +
        "&title=" +
        title,
      this.getTokenValue()
    );
  },
  findMenuCategoriesForSnapp: async function (
    branchId,
    unitId,
    contentType,
    filterMode,
    size,
    part,
    title
  ) {
    return await this.getApi(
      apiUrl.findMenuCategoriesForSnapp +
        "?branchId=" +
        branchId +
        "&unitId=" +
        unitId +
        "&contentType=" +
        contentType +
        "&filterMode=" +
        filterMode +
        "&size=" +
        size +
        "&part=" +
        part +
        "&title=" +
        title,
      this.getTokenValue()
    );
  },
  getCategoryInfo: async function (id) {
    return await this.getApi(
      apiUrl.getCategoryInfo + "?Id=" + id,
      this.getTokenValue()
    );
  },
  createCategory: async function (request) {
    return await this.postApi(
      apiUrl.createCategory,
      request,
      this.getTokenValue()
    );
  },
  removeSnappCategory: async function (id) {
    return await this.deleteApi(
      apiUrl.removeSnappCategory + id,
      this.getTokenValue()
    );
  },
  changeCategoryStatus: async function (request) {
    return await this.postApi(
      apiUrl.changeCategoryStatus,
      request,
      this.getTokenValue()
    );
  },
  getSnappMenus: async function (
    branchId,
    unitId,
    snappCategoryId,
    size,
    part,
    title
  ) {
    return await this.getApi(
      apiUrl.getSnappMenus +
        "/?branchId=" +
        branchId +
        "&unitId=" +
        unitId +
        "&snappCategoryId=" +
        snappCategoryId +
        "&size=" +
        size +
        "&part=" +
        part +
        "&title=" +
        title,
      this.getTokenValue()
    );
  },
  findSaleMenusForSnapp: async function (
    branchId,
    unitId,
    menuType,
    categoryId,
    size,
    part,
    title
  ) {
    return await this.getApi(
      apiUrl.findSaleMenusForSnapp +
        "/?branchId=" +
        branchId +
        "&unitId=" +
        unitId +
        "&menuType=" +
        menuType +
        "&categoryId=" +
        categoryId +
        "&size=" +
        size +
        "&part=" +
        part +
        "&title=" +
        title,
      this.getTokenValue()
    );
  },
  getSnappMenuInfo: async function (id) {
    return await this.getApi(
      apiUrl.getSnappMenuInfo + "/?Id=" + id,
      this.getTokenValue()
    );
  },
  createMenuSnapp: async function (request) {
    return await this.postApi(
      apiUrl.createMenuSnapp,
      request,
      this.getTokenValue()
    );
  },
  removeMenuSnapp: async function (id) {
    return await this.deleteApi(
      apiUrl.removeMenuSnapp + id,
      this.getTokenValue()
    );
  },
  changeMenuStatusSnapp: async function (request) {
    return await this.postApi(
      apiUrl.changeMenuStatusSnapp,
      request,
      this.getTokenValue()
    );
  },
  getToppingCategories: async function (branchId, unitId, size, part, title) {
    return await this.getApi(
      apiUrl.getToppingCategories +
        "/?branchId=" +
        branchId +
        "&unitId=" +
        unitId +
        "&size=" +
        size +
        "&part=" +
        part +
        "&title=" +
        title,
      this.getTokenValue()
    );
  },
  getSnappCategoryInfo: async function (id) {
    return await this.getApi(
      apiUrl.getSnappCategoryInfo + "/?Id=" + id,
      this.getTokenValue()
    );
  },
  createToppingCategory: async function (request) {
    return await this.postApi(
      apiUrl.createToppingCategory,
      request,
      this.getTokenValue()
    );
  },
  getSnappToppings: async function (
    branchId,
    unitId,
    snappCategoryId,
    title,
    part,
    size
  ) {
    return await this.getApi(
      apiUrl.getSnappToppings +
        "/?branchId=" +
        branchId +
        "&unitId=" +
        unitId +
        "&snappCategoryId=" +
        snappCategoryId +
        "&title=" +
        title +
        "&part=" +
        part +
        "&size=" +
        size,
      this.getTokenValue()
    );
  },
  getToppingInfo: async function (id) {
    return await this.getApi(
      apiUrl.getToppingInfo + "/?Id=" + id,
      this.getTokenValue()
    );
  },
  createTopping: async function (request) {
    return await this.postApi(
      apiUrl.createTopping,
      request,
      this.getTokenValue()
    );
  },
  syncCategoryToppings: async function (request) {
    return await this.postApi(
      apiUrl.syncCategoryToppings,
      request,
      this.getTokenValue()
    );
  },
  getDierctAllToppings: async function (request) {
    return await this.postApi(
      apiUrl.getDierctAllToppings,
      request,
      this.getTokenValue()
    );
  },
  findToppingsForMenu: async function (branchId, unitId, title, snappMenuId) {
    return await this.getApi(
      apiUrl.findToppingsForMenu +
        "/?branchId=" +
        branchId +
        "&unitId=" +
        unitId +
        "&title=" +
        title +
        "&snappMenuId=" +
        snappMenuId,
      this.getTokenValue()
    );
  },
  getSnappMenuToppings: async function (snappMenuId, title, part, size) {
    return await this.getApi(
      apiUrl.getSnappMenuToppings +
        "/?snappMenuId=" +
        snappMenuId +
        "&title=" +
        title +
        "&part=" +
        part +
        "&size=" +
        size,
      this.getTokenValue()
    );
  },
  addToppingToMenu: async function (request) {
    return await this.postApi(
      apiUrl.addToppingToMenu,
      request,
      this.getTokenValue()
    );
  },
  addBulkyToppingToMenu: async function (request) {
    return await this.postApi(
      apiUrl.addBulkyToppingToMenu,
      request,
      this.getTokenValue()
    );
  },
  removeToppingFromMenu: async function (request) {
    return await this.postApi(
      apiUrl.removeToppingFromMenu,
      request,
      this.getTokenValue()
    );
  },
  getSnappRecordes: async function (request) {
    return await this.postApi(
      apiUrl.getSnappRecordes,
      request,
      this.getTokenValue()
    );
  },
  syncSnappCategory: async function (request) {
    return await this.postApi(
      apiUrl.syncSnappCategory,
      request,
      this.getTokenValue()
    );
  },
  syncSnappMenu: async function (request) {
    return await this.postApi(
      apiUrl.syncSnappMenu,
      request,
      this.getTokenValue()
    );
  },

  getServicePriceTypes: async function () {
    return await this.getApi(apiUrl.getServicePriceTypes, this.getTokenValue());
  },
  findProducts: async function (branchId, title, code) {
    return await this.getApi(
      apiUrl.findProducts +
        "?branchId=" +
        branchId +
        "&title=" +
        title +
        "&code=" +
        code,
      this.getTokenValue()
    );
  },
  getServices: async function (branchId, size, part, title) {
    return await this.getApi(
      apiUrl.getServices +
        "?branchId=" +
        branchId +
        "&size=" +
        size +
        "&part=" +
        part +
        "&title=" +
        title,
      this.getTokenValue()
    );
  },
  getServiceInfo: async function (id) {
    return await this.getApi(
      apiUrl.getServiceInfo + "?Id=" + id,
      this.getTokenValue()
    );
  },
  createService: async function (request) {
    return await this.postApi(
      apiUrl.createService,
      request,
      this.getTokenValue()
    );
  },
  removeService: async function (id) {
    return await this.deleteApi(
      apiUrl.removeService + id,
      this.getTokenValue()
    );
  },
  enableService: async function (id) {
    return await this.putApi(
      apiUrl.enableService + id,
      null,
      this.getTokenValue()
    );
  },
  useInInvoice: async function (id) {
    return await this.putApi(
      apiUrl.useInInvoice + id,
      null,
      this.getTokenValue()
    );
  },
  getOrderingBaseInfo: async function (branchId) {
    return await this.getApi(
      apiUrl.getOrderingBaseInfo + "?branchId=" + branchId,
      this.getTokenValue()
    );
  },
  getUserCashdesks: async function (branchId, unitId) {
    return await this.getApi(
      apiUrl.getUserCashdesks + "?branchId=" + branchId + "&unitId=" + unitId,
      this.getTokenValue()
    );
  },
  getBranchSaleUnits: async function (branchId) {
    return await this.getApi(
      apiUrl.getBranchSaleUnits + "?branchId=" + branchId,
      this.getTokenValue()
    );
  },
  getMenuCategoriesOrders: async function (branchId, unitId) {
    return await this.getApi(
      apiUrl.getMenuCategoriesOrders +
        "?branchId=" +
        branchId +
        "&unitId=" +
        unitId +
        "&title=",
      this.getTokenValue()
    );
  },
  getOrderSaleMenus: async function (
    branchId,
    unitId,
    categoryId,
    size,
    part,
    title
  ) {
    return await this.getApi(
      apiUrl.getOrderSaleMenus +
        "?branchId=" +
        branchId +
        "&unitId=" +
        unitId +
        "&categoryId=" +
        categoryId +
        "&size=" +
        size +
        "&part=" +
        part +
        "&title=" +
        title,
      this.getTokenValue()
    );
  },
  findOrdersMerchants: async function (
    branchId,
    size,
    part,
    mobile,
    code,
    name,
    merchantType,
    creditable
  ) {
    return await this.getApi(
      apiUrl.findOrdersMerchants +
        "?branchId=" +
        branchId +
        "&size=" +
        size +
        "&part=" +
        part +
        "&mobile=" +
        mobile +
        "&code=" +
        code +
        "&name=" +
        name +
        "&merchantType=" +
        merchantType +
        "&creditable=" +
        creditable,
      this.getTokenValue()
    );
  },
  getCashdeskOrders: async function (
    branchId,
    deskId,
    size,
    part,
    invoiceNumber,
    orderNumber,
    status
  ) {
    return await this.getApi(
      apiUrl.getCashdeskOrders +
        "?branchId=" +
        branchId +
        "&deskId=" +
        deskId +
        "&size=" +
        size +
        "&part=" +
        part +
        "&invoiceNumber=" +
        invoiceNumber +
        "&orderNumber=" +
        orderNumber +
        "&status=" +
        status,
      this.getTokenValue()
    );
  },
  getCanceledOrders: async function (
    branchId,
    deskId,
    size,
    part,
    invoiceNumber
  ) {
    return await this.getApi(
      apiUrl.getCanceledOrders +
        "?branchId=" +
        branchId +
        "&deskId=" +
        deskId +
        "&size=" +
        size +
        "&part=" +
        part +
        "&invoiceNumber=" +
        invoiceNumber,
      this.getTokenValue()
    );
  },
  setTotalDiscount: async function (request) {
    return await this.postApi(
      apiUrl.setTotalDiscount,
      request,
      this.getTokenValue()
    );
  },
  getMerchantPreviousOrders: async function (
    branchId,
    userId,
    size,
    part,
    repCount
  ) {
    return await this.getApi(
      apiUrl.getMerchantPreviousOrders +
        "?branchId=" +
        branchId +
        "&userId=" +
        userId +
        "&size=" +
        size +
        "&part=" +
        part +
        "&repCount=" +
        repCount,
      this.getTokenValue()
    );
  },
  getOrderTypes: async function () {
    return await this.getApi(apiUrl.getOrderTypes, this.getTokenValue());
  },
  getInvoiceItemTypes: async function () {
    return await this.getApi(apiUrl.getInvoiceItemTypes, this.getTokenValue());
  },
  createBulkOrder: async function (request) {
    return await this.postApi(
      apiUrl.createBulkOrder,
      request,
      this.getTokenValue()
    );
  },
  getBulkOrderInfo: async function (invoiceId) {
    return await this.getApi(
      apiUrl.getBulkOrderInfo + "?invoiceId=" + invoiceId,
      this.getTokenValue()
    );
  },
  getMerchants: async function (
    branchId,
    size,
    part,
    code,
    mobile,
    firstName,
    lastName,
    merchantType,
    creditable
  ) {
    return await this.getApi(
      apiUrl.getMerchants +
        "?branchId=" +
        branchId +
        "&size=" +
        size +
        "&part=" +
        part +
        "&code=" +
        code +
        "&mobile=" +
        mobile +
        "&firstName=" +
        firstName +
        "&lastName=" +
        lastName +
        "&merchantType=" +
        merchantType +
        "&creditable=" +
        creditable,
      this.getTokenValue()
    );
  },
  getMerchantInfo: async function (id) {
    return await this.getApi(
      apiUrl.getMerchantInfo + "?Id=" + id,
      this.getTokenValue()
    );
  },
  createMerchant: async function (request) {
    return await this.postApi(
      apiUrl.createMerchant,
      request,
      this.getTokenValue()
    );
  },
  removeMerchant: async function (id) {
    return await this.deleteApi(
      apiUrl.removeMerchant + "/" + id,
      this.getTokenValue()
    );
  },
  getMerchantAdresses: async function (merchantId, size, part, title) {
    return await this.getApi(
      apiUrl.getMerchantAdresses +
        "?merchantId=" +
        merchantId +
        "&size=" +
        size +
        "&part=" +
        part +
        "&title=" +
        title,
      this.getTokenValue()
    );
  },
  getAddressInfo: async function (id) {
    return await this.getApi(
      apiUrl.getAddressInfo + "?Id=" + id,
      this.getTokenValue()
    );
  },
  createAddress: async function (request) {
    return await this.postApi(
      apiUrl.createAddress,
      request,
      this.getTokenValue()
    );
  },
  removeAddress: async function (id) {
    return await this.deleteApi(
      apiUrl.removeAddress + "/" + id,
      this.getTokenValue()
    );
  },
  getMerchantAndAddressesInfo: async function (id) {
    return await this.getApi(
      apiUrl.getMerchantAndAddressesInfo + "/?Id=" + id,
      this.getTokenValue()
    );
  },
  createMerchantWithAddress: async function (request) {
    return await this.postApi(
      apiUrl.createMerchantWithAddress,
      request,
      this.getTokenValue()
    );
  },
  createOrderItem: async function (request) {
    return await this.postApi(
      apiUrl.createOrderItem,
      request,
      this.getTokenValue()
    );
  },
  removeOrderItem: async function (id) {
    return await this.deleteApi(
      apiUrl.removeOrderItem + id,
      this.getTokenValue()
    );
  },
  changeOrderItemAmount: async function (request) {
    return await this.postApi(
      apiUrl.changeOrderItemAmount,
      request,
      this.getTokenValue()
    );
  },
  createOrder: async function (request) {
    return await this.postApi(
      apiUrl.createOrder,
      request,
      this.getTokenValue()
    );
  },
  removeOrder: async function (id) {
    return await this.deleteApi(apiUrl.removeOrder + id, this.getTokenValue());
  },
  sendOrderToKitchen: async function (id) {
    return await this.putApi(
      apiUrl.sendOrderToKitchen + id,
      null,
      this.getTokenValue()
    );
  },
  cancelOrder: async function (id) {
    return await this.putApi(
      apiUrl.cancelOrder + id,
      null,
      this.getTokenValue()
    );
  },
  getOrderItemInfo: async function (id) {
    return await this.getApi(
      apiUrl.getOrderItemInfo + "?Id=" + id,
      this.getTokenValue()
    );
  },
  getOrderItems: async function (id) {
    return await this.getApi(
      apiUrl.getOrderItems + "?Id=" + id,
      this.getTokenValue()
    );
  },
  addMenuToOrderItem: async function (request) {
    return await this.postApi(
      apiUrl.addMenuToOrderItem,
      request,
      this.getTokenValue()
    );
  },
  removeMenuFromOrderItem: async function (request) {
    return await this.postApi(
      apiUrl.removeMenuFromOrderItem,
      request,
      this.getTokenValue()
    );
  },
  getUserAddresses: async function (size, part, userId, title, address) {
    return await this.getApi(
      apiUrl.getUserAddresses +
        "?size=" +
        size +
        "&part=" +
        part +
        "&userId=" +
        userId +
        "&title=" +
        title +
        "&address=" +
        address,
      this.getTokenValue()
    );
  },
  getUserAddressInfo: async function (id) {
    return await this.getApi(
      apiUrl.getUserAddressInfo + "?Id=" + id,
      this.getTokenValue()
    );
  },
  createUserAddress: async function (request) {
    return await this.postApi(
      apiUrl.createUserAddress,
      request,
      this.getTokenValue()
    );
  },
  removeUserAddress: async function (id) {
    return await this.deleteApi(
      apiUrl.removeUserAddress + id,
      this.getTokenValue()
    );
  },
  getLoginedWaiterInfo: async function () {
    return await this.getApi(apiUrl.getLoginedWaiterInfo, this.getTokenValue());
  },
  getLoginedStaffInfo: async function (employeeType) {
    return await this.getApi(
      apiUrl.getLoginedStaffInfo + "/?employeeType=" + employeeType,
      this.getTokenValue()
    );
  },
  getOrderPrintInfo: async function (invoiceId) {
    return await this.getApi(
      apiUrl.getOrderPrintInfo + "/?invoiceId=" + invoiceId,
      this.getTokenValue()
    );
  },
  getOrderNoTaxPrintInfo: async function (invoiceId) {
    return await this.getApi(
      apiUrl.getOrderNoTaxPrintInfo + "/?invoiceId=" + invoiceId,
      this.getTokenValue()
    );
  },
  getLocalPrinters: async function (baseUrl) {
    return await this.getApi(
      baseUrl + apiUrl.getLocalPrinters,
      this.getTokenValue()
    );
  },
  printImage: async function (baseUrl, request) {
    return await this.postApi(
      baseUrl + apiUrl.printImage,
      request,
      this.getTokenValue()
    );
  },
  kitchenCorrectionPrint: async function (baseUrl, request) {
    return await this.postApi(
      baseUrl + apiUrl.kitchenCorrectionPrint,
      request,
      this.getTokenValue()
    );
  },
  kitchenOrderPrint: async function (baseUrl, request) {
    return await this.postApi(
      baseUrl + apiUrl.kitchenOrderPrint,
      request,
      this.getTokenValue()
    );
  },
  orderBillPrint: async function (baseUrl, request) {
    return await this.postApi(
      baseUrl + apiUrl.orderBillPrint,
      request,
      this.getTokenValue()
    );
  },
  getOfficialInvoiceExcelFile: async function (invoiceId) {
    return await this.getApi(
      apiUrl.getOfficialInvoiceExcelFile + "/?invoiceId=" + invoiceId,
      this.getTokenValue()
    );
  },
  getOrderDeskPosDevices: async function (deskId) {
    return await this.getApi(
      apiUrl.getOrderDeskPosDevices + "/?deskId=" + deskId,
      this.getTokenValue()
    );
  },
  orderPayment: async function (request) {
    return await this.postApi(
      apiUrl.orderPayment,
      request,
      this.getTokenValue()
    );
  },
  getOrderStatuses: async function () {
    return await this.getApi(apiUrl.getOrderStatuses, this.getTokenValue());
  },
  getInvoices: async function (
    branchId,
    orderNumber,
    saleUnitId,
    cashDeskId,
    posDeviceId,
    invoiceNumber,
    merchantName,
    merchantPhone,
    merchantCode,
    orderType,
    paymentType,
    orderStatus,
    startDate,
    startTime,
    endDate,
    endTime,
    part,
    size
  ) {
    return await this.getApi(
      apiUrl.getInvoices +
        "?branchId=" +
        branchId +
        "&orderNumber=" +
        orderNumber +
        "&saleUnitId=" +
        saleUnitId +
        "&cashDeskId=" +
        cashDeskId +
        "&posDeviceId=" +
        posDeviceId +
        "&invoiceNumber=" +
        invoiceNumber +
        "&merchantName=" +
        merchantName +
        "&merchantPhone=" +
        merchantPhone +
        "&merchantCode=" +
        merchantCode +
        "&orderType=" +
        orderType +
        "&paymentType=" +
        paymentType +
        "&orderStatus=" +
        orderStatus +
        "&startDate=" +
        startDate +
        "&startTime=" +
        startTime +
        "&endDate=" +
        endDate +
        "&endTime=" +
        endTime +
        "&part=" +
        part +
        "&size=" +
        size,
      this.getTokenValue()
    );
  },
  createInvoice: async function (request) {
    return await this.postApi(
      apiUrl.createInvoice,
      request,
      this.getTokenValue()
    );
  },
  getPaymentTypes: async function () {
    return await this.getApi(apiUrl.getPaymentTypes, this.getTokenValue());
  },
  getKitchenOrders: async function (
    branchId,
    saleUnitId,
    orderNumber,
    cashDeskId,
    posDeviceId,
    invoiceNumber,
    merchantName,
    merchantPhone,
    merchantCode,
    orderType,
    paymentType,
    orderStatus,
    startDate,
    endDate,
    part,
    size
  ) {
    return await this.getApi(
      apiUrl.getKitchenOrders +
        "?branchId=" +
        branchId +
        "&saleUnitId=" +
        saleUnitId +
        "&orderNumber=" +
        orderNumber +
        "&cashDeskId=" +
        cashDeskId +
        "&posDeviceId=" +
        posDeviceId +
        "&invoiceNumber=" +
        invoiceNumber +
        "&merchantName=" +
        merchantName +
        "&merchantPhone=" +
        merchantPhone +
        "&merchantCode=" +
        merchantCode +
        "&orderType=" +
        orderType +
        "&paymentType=" +
        paymentType +
        "&orderStatus=" +
        orderStatus +
        "&startDate=" +
        startDate +
        "&endDate=" +
        endDate +
        "&part=" +
        part +
        "&size=" +
        size,
      this.getTokenValue()
    );
  },
  getKitchenArchive: async function (
    branchId,
    saleUnitId,
    orderNumber,
    cashDeskId,
    posDeviceId,
    invoiceNumber,
    merchantName,
    merchantPhone,
    merchantCode,
    orderType,
    paymentType,
    orderStatus,
    startDate,
    endDate,
    part,
    size
  ) {
    return await this.getApi(
      apiUrl.getKitchenArchive +
        "?branchId=" +
        branchId +
        "&saleUnitId=" +
        saleUnitId +
        "&orderNumber=" +
        orderNumber +
        "&cashDeskId=" +
        cashDeskId +
        "&posDeviceId=" +
        posDeviceId +
        "&invoiceNumber=" +
        invoiceNumber +
        "&merchantName=" +
        merchantName +
        "&merchantPhone=" +
        merchantPhone +
        "&merchantCode=" +
        merchantCode +
        "&orderType=" +
        orderType +
        "&paymentType=" +
        paymentType +
        "&orderStatus=" +
        orderStatus +
        "&startDate=" +
        startDate +
        "&endDate=" +
        endDate +
        "&part=" +
        part +
        "&size=" +
        size,
      this.getTokenValue()
    );
  },
  changeToCookedOrder: async function (invoiceId) {
    return await this.putApi(
      apiUrl.changeToCookedOrder + invoiceId,
      null,
      this.getTokenValue()
    );
  },
  backToCurrentOrder: async function (invoiceId) {
    return await this.putApi(
      apiUrl.backToCurrentOrder + invoiceId,
      null,
      this.getTokenValue()
    );
  },
  kitchenCancelOrder: async function (invoiceId) {
    return await this.putApi(
      apiUrl.kitchenCancelOrder + invoiceId,
      null,
      this.getTokenValue()
    );
  },
  cancelPayment: async function (request) {
    return await this.postApi(
      apiUrl.cancelPayment,
      request,
      this.getTokenValue()
    );
  },
  getCoockedOrders: async function (
    branchId,
    orderNumber,
    saleUnitId,
    cashDeskId,
    posDeviceId,
    invoiceNumber,
    merchantName,
    merchantPhone,
    merchantCode,
    destination,
    orderType,
    paymentType,
    orderStatus,
    startDate,
    endDate,
    part,
    size
  ) {
    return await this.getApi(
      apiUrl.getCoockedOrders +
        "?branchId=" +
        branchId +
        "&orderNumber=" +
        orderNumber +
        "&saleUnitId=" +
        saleUnitId +
        "&cashDeskId=" +
        cashDeskId +
        "&posDeviceId=" +
        posDeviceId +
        "&invoiceNumber=" +
        invoiceNumber +
        "&merchantName=" +
        merchantName +
        "&merchantPhone=" +
        merchantPhone +
        "&merchantCode=" +
        merchantCode +
        "&destination=" +
        destination +
        "&orderType=" +
        orderType +
        "&paymentType=" +
        paymentType +
        "&orderStatus=" +
        orderStatus +
        "&startDate=" +
        startDate +
        "&endDate=" +
        endDate +
        "&part=" +
        part +
        "&size=" +
        size,
      this.getTokenValue()
    );
  },
  getDeliveredOrderArchive: async function (
    branchId,
    orderNumber,
    saleUnitId,
    cashDeskId,
    posDeviceId,
    invoiceNumber,
    merchantName,
    merchantPhone,
    merchantCode,
    destination,
    orderType,
    paymentType,
    orderStatus,
    startDate,
    endDate,
    part,
    size
  ) {
    return await this.getApi(
      apiUrl.getDeliveredOrderArchive +
        "?branchId=" +
        branchId +
        "&orderNumber=" +
        orderNumber +
        "&saleUnitId=" +
        saleUnitId +
        "&cashDeskId=" +
        cashDeskId +
        "&posDeviceId=" +
        posDeviceId +
        "&invoiceNumber=" +
        invoiceNumber +
        "&merchantName=" +
        merchantName +
        "&merchantPhone=" +
        merchantPhone +
        "&merchantCode=" +
        merchantCode +
        "&destination=" +
        destination +
        "&orderType=" +
        orderType +
        "&paymentType=" +
        paymentType +
        "&orderStatus=" +
        orderStatus +
        "&startDate=" +
        startDate +
        "&endDate=" +
        endDate +
        "&part=" +
        part +
        "&size=" +
        size,
      this.getTokenValue()
    );
  },
  getDriveryOrderArchive: async function (
    branchId,
    orderNumber,
    saleUnitId,
    cashDeskId,
    posDeviceId,
    invoiceNumber,
    merchantName,
    merchantPhone,
    merchantCode,
    destination,
    orderType,
    paymentType,
    orderStatus,
    startDate,
    endDate,
    part,
    size
  ) {
    return await this.getApi(
      apiUrl.getDriveryOrderArchive +
        "?branchId=" +
        branchId +
        "&orderNumber=" +
        orderNumber +
        "&saleUnitId=" +
        saleUnitId +
        "&cashDeskId=" +
        cashDeskId +
        "&posDeviceId=" +
        posDeviceId +
        "&invoiceNumber=" +
        invoiceNumber +
        "&merchantName=" +
        merchantName +
        "&merchantPhone=" +
        merchantPhone +
        "&merchantCode=" +
        merchantCode +
        "&destination=" +
        destination +
        "&orderType=" +
        orderType +
        "&paymentType=" +
        paymentType +
        "&orderStatus=" +
        orderStatus +
        "&startDate=" +
        startDate +
        "&endDate=" +
        endDate +
        "&part=" +
        part +
        "&size=" +
        size,
      this.getTokenValue()
    );
  },
  deliveryOrderToDriver: async function (request) {
    return await this.postApi(
      apiUrl.deliveryOrderToDriver,
      request,
      this.getTokenValue()
    );
  },
  deliveryOrderToDriverBulky: async function (request) {
    return await this.postApi(
      apiUrl.deliveryOrderToDriverBulky,
      request,
      this.getTokenValue()
    );
  },
  deliveryOrderToShipment: async function (request) {
    return await this.postApi(
      apiUrl.deliveryOrderToShipment,
      request,
      this.getTokenValue()
    );
  },
  deliveryOrderToMerchant: async function (id) {
    return await this.putApi(
      apiUrl.deliveryOrderToMerchant + id,
      null,
      this.getTokenValue()
    );
  },
  deliveryOrderToWaiter: async function (request) {
    return await this.postApi(
      apiUrl.deliveryOrderToWaiter,
      request,
      this.getTokenValue()
    );
  },
  getDeliveryUserOrders: async function (
    invoiceNumber,
    orderNumber,
    merchantPhone,
    merchantName,
    merchantCode,
    startDate,
    endDate,
    part,
    size
  ) {
    return await this.getApi(
      apiUrl.getDeliveryUserOrders +
        "/?invoiceNumber=" +
        invoiceNumber +
        "&orderNumber=" +
        orderNumber +
        "&merchantPhone=" +
        merchantPhone +
        "&merchantName=" +
        merchantName +
        "&merchantCode=" +
        merchantCode +
        "&startDate=" +
        startDate +
        "&endDate=" +
        endDate +
        "&part=" +
        part +
        "&size=" +
        size,
      this.getTokenValue()
    );
  },
  getUserPosDevices: async function () {
    return await this.getApi(apiUrl.getUserPosDevices, this.getTokenValue());
  },
  confirmOrder: async function (id) {
    return await this.putApi(
      apiUrl.confirmOrder + id,
      null,
      this.getTokenValue()
    );
  },

  getPricingTypes: async function () {
    return await this.getApi(apiUrl.getPricingTypes, this.getTokenValue());
  },
  getProductCategories: async function (branchId, title, size, part) {
    return await this.getApi(
      apiUrl.getProductCategories +
        "/?branchId=" +
        branchId +
        "&title=" +
        title +
        "&size=" +
        size +
        "&part=" +
        part,
      this.getTokenValue()
    );
  },
  getRestaurantProductCategories: async function (
    restaurantId,
    title,
    size,
    part
  ) {
    return await this.getApi(
      apiUrl.getRestaurantProductCategories +
        "/?restaurantId=" +
        restaurantId +
        "&title=" +
        title +
        "&size=" +
        size +
        "&part=" +
        part,
      this.getTokenValue()
    );
  },
  getProductCategoryInfo: async function (id) {
    return await this.getApi(
      apiUrl.getProductCategoryInfo + "/?Id=" + id,
      this.getTokenValue()
    );
  },
  createProductCategory: async function (request) {
    return await this.postApi(
      apiUrl.createProductCategory,
      request,
      this.getTokenValue()
    );
  },
  createRestaurantProductCategory: async function (request) {
    return await this.postApi(
      apiUrl.createRestaurantProductCategory,
      request,
      this.getTokenValue()
    );
  },
  removeProductCategory: async function (id) {
    return await this.deleteApi(
      apiUrl.removeProductCategory + id,
      this.getTokenValue()
    );
  },
  getMeasurementDimensionTypes: async function () {
    return await this.getApi(
      apiUrl.getMeasurementDimensionTypes,
      this.getTokenValue()
    );
  },
  getUnitMeasurements: async function (branchId, title, size, part) {
    return await this.getApi(
      apiUrl.getUnitMeasurements +
        "/?branchId=" +
        branchId +
        "&title=" +
        title +
        "&size=" +
        size +
        "&part=" +
        part,
      this.getTokenValue()
    );
  },
  getRestaurantUnitMeasurements: async function (
    restaurantId,
    title,
    size,
    part
  ) {
    return await this.getApi(
      apiUrl.getRestaurantUnitMeasurements +
        "/?restaurantId=" +
        restaurantId +
        "&title=" +
        title +
        "&size=" +
        size +
        "&part=" +
        part,
      this.getTokenValue()
    );
  },
  getUnitMeasurementInfo: async function (id) {
    return await this.getApi(
      apiUrl.getUnitMeasurementInfo + "/?Id=" + id,
      this.getTokenValue()
    );
  },
  createUnitMeasurement: async function (request) {
    return await this.postApi(
      apiUrl.createUnitMeasurement,
      request,
      this.getTokenValue()
    );
  },
  createRestaurantUnitMeasurement: async function (request) {
    return await this.postApi(
      apiUrl.createRestaurantUnitMeasurement,
      request,
      this.getTokenValue()
    );
  },
  enableUnitMeasurement: async function (id) {
    return await this.putApi(
      apiUrl.enableUnitMeasurement + id,
      null,
      this.getTokenValue()
    );
  },
  removeUnitMeasurement: async function (id) {
    return await this.deleteApi(
      apiUrl.removeUnitMeasurement + id,
      this.getTokenValue()
    );
  },
  getProductTypes: async function () {
    return await this.getApi(apiUrl.getProductTypes, this.getTokenValue());
  },
  getNatureType: async function () {
    return await this.getApi(apiUrl.getNatureType, this.getTokenValue());
  },
  getProducts: async function (
    branchId,
    productType,
    natureType,
    title,
    code,
    size,
    part
  ) {
    return await this.getApi(
      apiUrl.getProducts +
        "/?branchId=" +
        branchId +
        "&productType=" +
        productType +
        "&natureType=" +
        natureType +
        "&title=" +
        title +
        "&code=" +
        code +
        "&size=" +
        size +
        "&part=" +
        part,
      this.getTokenValue()
    );
  },
  getRestaurantProducts: async function (
    restaurantId,
    productType,
    natureType,
    title,
    code,
    size,
    part
  ) {
    return await this.getApi(
      apiUrl.getRestaurantProducts +
        "/?restaurantId=" +
        restaurantId +
        "&productType=" +
        productType +
        "&natureType=" +
        natureType +
        "&title=" +
        title +
        "&code=" +
        code +
        "&size=" +
        size +
        "&part=" +
        part,
      this.getTokenValue()
    );
  },
  getRestaurantServices: async function (
    restaurantId,
    productType,
    natureType,
    title,
    code,
    size,
    part
  ) {
    return await this.getApi(
      apiUrl.getRestaurantServices +
        "/?restaurantId=" +
        restaurantId +
        "&productType=" +
        productType +
        "&natureType=" +
        natureType +
        "&title=" +
        title +
        "&code=" +
        code +
        "&size=" +
        size +
        "&part=" +
        part,
      this.getTokenValue()
    );
  },
  getProductMeasurements: async function (productId, title, size, part) {
    return await this.getApi(
      apiUrl.getProductMeasurements +
        "?productId=" +
        productId +
        "&title=" +
        title +
        "&size=" +
        size +
        "&part=" +
        part,
      this.getTokenValue()
    );
  },
  getProductInfo: async function (id) {
    return await this.getApi(
      apiUrl.getProductInfo + "/?Id=" + id,
      this.getTokenValue()
    );
  },
  getProductMeasurementInfo: async function (id) {
    return await this.getApi(
      apiUrl.getProductMeasurementInfo + "/?Id=" + id,
      this.getTokenValue()
    );
  },
  createProduct: async function (request) {
    return await this.postApi(
      apiUrl.createProduct,
      request,
      this.getTokenValue()
    );
  },
  createRestaurantProduct: async function (request) {
    return await this.postApi(
      apiUrl.createRestaurantProduct,
      request,
      this.getTokenValue()
    );
  },
  ceateProductMeasurement: async function (request) {
    return await this.postApi(
      apiUrl.ceateProductMeasurement,
      request,
      this.getTokenValue()
    );
  },
  removeProduct: async function (id) {
    return await this.deleteApi(
      apiUrl.removeProduct + id,
      this.getTokenValue()
    );
  },
  removeProductMeasurement: async function (id) {
    return await this.deleteApi(
      apiUrl.removeProductMeasurement + id,
      this.getTokenValue()
    );
  },
  getBranchOrderCounts: async function (branchId) {
    return await this.getApi(
      apiUrl.getBranchOrderCounts + "?branchId=" + branchId,
      this.getTokenValue()
    );
  },
  getSnappStatuses: async function () {
    return await this.getApi(apiUrl.getSnappStatuses, this.getTokenValue());
  },
  getSnappOrders: async function (request) {
    return await this.postApi(
      apiUrl.getSnappOrders,
      request,
      this.getTokenValue()
    );
  },
  getWatchItemInfo: async function (watchId) {
    return await this.getApi(
      apiUrl.getWatchItemInfo + "?watchId=" + watchId,
      this.getTokenValue()
    );
  },
  verifySnappOrder: async function (request) {
    return await this.postApi(
      apiUrl.verifySnappOrder,
      request,
      this.getTokenValue()
    );
  },
  pickSnappOrder: async function (request) {
    return await this.postApi(
      apiUrl.pickSnappOrder,
      request,
      this.getTokenValue()
    );
  },
  pickSnappOrderDierctly: async function (request) {
    return await this.postApi(
      apiUrl.pickSnappOrderDierctly,
      request,
      this.getTokenValue()
    );
  },
  acceptSnappOrder: async function (request) {
    return await this.postApi(
      apiUrl.acceptSnappOrder,
      request,
      this.getTokenValue()
    );
  },
  rejectSnappOrder: async function (request) {
    return await this.postApi(
      apiUrl.rejectSnappOrder,
      request,
      this.getTokenValue()
    );
  },
  getSnappRejectReasons: async function (request) {
    return await this.postApi(
      apiUrl.getSnappRejectReasons,
      request,
      this.getTokenValue()
    );
  },
  searchSnappProducts: async function (branchId, size, part, title) {
    return await this.getApi(
      apiUrl.searchSnappProducts +
        "?branchId=" +
        branchId +
        "&size=" +
        size +
        "&part=" +
        part +
        "&title=" +
        title,
      this.getTokenValue()
    );
  },
  acceptAndImportSnappOrder: async function (request) {
    return await this.postApi(
      apiUrl.acceptAndImportSnappOrder,
      request,
      this.getTokenValue()
    );
  },
  getSnappOrderPrintInfo: async function (snappOrderId) {
    return await this.getApi(
      apiUrl.getSnappOrderPrintInfo + "?snappOrderId=" + snappOrderId,
      this.getTokenValue()
    );
  },
  getSnappServiceTypes: async function () {
    return await this.getApi(apiUrl.getSnappServiceTypes, this.getTokenValue());
  },
  getSnappServicePrices: async function (branchId, title, code, size, part) {
    return await this.getApi(
      apiUrl.getSnappServicePrices +
        "?branchId=" +
        branchId +
        "&title=" +
        title +
        "&code=" +
        code +
        "&size=" +
        size +
        "&part=" +
        part,
      this.getTokenValue()
    );
  },
  getSnappServicePriceInfo: async function (id) {
    return await this.getApi(
      apiUrl.getSnappServicePriceInfo + "?id=" + id,
      this.getTokenValue()
    );
  },
  createSnappServicePrice: async function (request) {
    return await this.postApi(
      apiUrl.createSnappServicePrice,
      request,
      this.getTokenValue()
    );
  },
  removeSnappServicePrice: async function (id) {
    return await this.deleteApi(
      apiUrl.removeSnappServicePrice + id,
      this.getTokenValue()
    );
  },
  enableSnappServicePrice: async function (id) {
    return await this.putApi(
      apiUrl.enableSnappServicePrice + id,
      null,
      this.getTokenValue()
    );
  },
  getCallCenterInfo: async function (branchId) {
    return await this.getApi(
      apiUrl.getCallCenterInfo + "?branchId=" + branchId,
      this.getTokenValue()
    );
  },
  createCallCenterInfo: async function (request) {
    return await this.postApi(
      apiUrl.createCallCenterInfo,
      request,
      this.getTokenValue()
    );
  },
  getSalesUnitShopQrImage: async function (id) {
    return await this.getApi(
      apiUrl.getSalesUnitShopQrImage + "?saleUnitId=" + id,
      this.getTokenValue()
    );
  },
  removeCallcenter: async function (id) {
    return await this.deleteApi(
      apiUrl.removeCallcenter + id,
      this.getTokenValue()
    );
  },
  getCreditMerchants: async function (
    branchId,
    size,
    part,
    code,
    mobile,
    name,
    creditable,
    merchantType
  ) {
    return await this.getApi(
      apiUrl.getCreditMerchants +
        "?branchId=" +
        branchId +
        "&size=" +
        size +
        "&part=" +
        part +
        "&code=" +
        code +
        "&mobile=" +
        mobile +
        "&name=" +
        name +
        "&creditable=" +
        creditable +
        "&merchantType=" +
        merchantType,
      this.getTokenValue()
    );
  },
  getMerchantWalletInfo: async function (merchantId) {
    return await this.getApi(
      apiUrl.getMerchantWalletInfo + "?merchantId=" + merchantId,
      this.getTokenValue()
    );
  },
  createMerchantWallet: async function (request) {
    return await this.postApi(
      apiUrl.createMerchantWallet,
      request,
      this.getTokenValue()
    );
  },
  changeCreditableMerchant: async function (id) {
    return await this.putApi(
      apiUrl.changeCreditableMerchant + id,
      null,
      this.getTokenValue()
    );
  },
  getSalesProductReport: async function (request) {
    return await this.postApi(
      apiUrl.getSalesProductReport,
      request,
      this.getTokenValue()
    );
  },
  getSalesInvoiceReport: async function (request) {
    return await this.postApi(
      apiUrl.getSalesInvoiceReport,
      request,
      this.getTokenValue()
    );
  },
  getSalesInvoiceItemReport: async function (request) {
    return await this.postApi(
      apiUrl.getSalesInvoiceItemReport,
      request,
      this.getTokenValue()
    );
  },
  getSalesTotalReport: async function (request) {
    return await this.postApi(
      apiUrl.getSalesTotalReport,
      request,
      this.getTokenValue()
    );
  },
  getMerchantReport: async function (request) {
    return await this.postApi(
      apiUrl.getMerchantReport,
      request,
      this.getTokenValue()
    );
  },
  getSnappSalesReport: async function (request) {
    return await this.postApi(
      apiUrl.getSnappSalesReport,
      request,
      this.getTokenValue()
    );
  },
  getSnappRejectSides: async function () {
    return await this.getApi(apiUrl.getSnappRejectSides, this.getTokenValue());
  },
  getSnappDeliveryTypes: async function () {
    return await this.getApi(
      apiUrl.getSnappDeliveryTypes,
      this.getTokenValue()
    );
  },
  getSnappPaymentTypes: async function () {
    return await this.getApi(apiUrl.getSnappPaymentTypes, this.getTokenValue());
  },
  getSalesProductExcel: async function (request) {
    return await this.postApi(
      apiUrl.getSalesProductExcel,
      request,
      this.getTokenValue()
    );
  },
  getSalesInvoiceExcel: async function (request) {
    return await this.postApi(
      apiUrl.getSalesInvoiceExcel,
      request,
      this.getTokenValue()
    );
  },
  getSalesInvoiceItemExcel: async function (request) {
    return await this.postApi(
      apiUrl.getSalesInvoiceItemExcel,
      request,
      this.getTokenValue()
    );
  },
  getAvalibleCashdesks: async function (branchId) {
    return await this.getApi(
      apiUrl.getAvalibleCashdesks + "/?branchId=" + branchId,
      this.getTokenValue()
    );
  },

  getMerchantInvoicesForSupport: async function (request) {
    return await this.postApi(
      apiUrl.getMerchantInvoicesForSupport,
      request,
      this.getTokenValue()
    );
  },

  getSalesInvoiceExcel: async function (request) {
    return await this.postApi(
      apiUrl.getSalesInvoiceExcel,
      request,
      this.getTokenValue()
    );
  },
  getMerchantReportExcel: async function (request) {
    return await this.postApi(
      apiUrl.getMerchantReportExcel,
      request,
      this.getTokenValue()
    );
  },
  getSalesTotalExcel: async function (request) {
    return await this.postApi(
      apiUrl.getSalesTotalExcel,
      request,
      this.getTokenValue()
    );
  },

  /*** WarHouse Apis ***/
  getWarehouseCategories: async function (
    branchId,
    parentId,
    restaurantId,
    title,
    size,
    part
  ) {
    return await this.getApi(
      apiUrl.getWarehouseCategories +
        "?branchId=" +
        branchId +
        "&parentId=" +
        parentId +
        "&restaurantId=" +
        restaurantId +
        "&title=" +
        title +
        "&size=" +
        size +
        "&part=" +
        part,
      this.getTokenValue()
    );
  },

  getWarehouseCategoriesTree: async function (
    branchId,
    parentId,
    restaurantId,
    title,
    size,
    part
  ) {
    const params = {
      branchId,
      parentId,
      restaurantId,
      title,
      size,
      part,
    };

    const queryString = Object.entries(params)
      .filter(
        ([_, value]) => value !== null && value !== undefined && value !== ""
      )
      .map(
        ([key, value]) =>
          `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
      )
      .join("&");

    return await this.getApi(
      apiUrl.getWarehouseCategories + (queryString ? `?${queryString}` : ""),
      this.getTokenValue()
    );
  },
  getWarehouseCategoryInfo: async function (id) {
    return await this.getApi(
      apiUrl.getWarehouseCategoryInfo + "?Id=" + id,
      this.getTokenValue()
    );
  },
  removeWarehouseCategory: async function (id) {
    return await this.deleteApi(
      apiUrl.removeWarehouseCategory + "/" + id,
      this.getTokenValue()
    );
  },
  createWarehouseCategory: async function (request) {
    return await this.postApi(
      apiUrl.createWarehouseCategory,
      request,
      this.getTokenValue()
    );
  },
  getAllWarehouseCategories: async function (branchId, restaurantId, title) {
    return await this.getApi(
      apiUrl.getAllWarehouseCategories +
        "?branchId=" +
        branchId +
        "&restaurantId=" +
        restaurantId +
        "&title=" +
        title,
      this.getTokenValue()
    );
  },
  getWarehouses: async function (
    branchId,
    restaurantId,
    title,
    code,
    size,
    part
  ) {
    return await this.getApi(
      apiUrl.getWarehouses +
        "?branchId=" +
        branchId +
        "&restaurantId=" +
        restaurantId +
        "&title=" +
        title +
        "&code=" +
        code +
        "&size=" +
        size +
        "&part=" +
        part,
      this.getTokenValue()
    );
  },

  getWarehousesByCategory(categoryId, restaurantId) {
    return this.getApi(
      `${apiUrl.getWarehouses}?CategoryId=${categoryId}&RestaurantId=${restaurantId}`,
      this.getTokenValue()
    );
  },
  getWarehouseInfo: async function (id) {
    return await this.getApi(
      apiUrl.getWarehouseInfo + "?Id=" + id,
      this.getTokenValue()
    );
  },
  createWarehouse: async function (request) {
    return await this.postApi(
      apiUrl.createWarehouse,
      request,
      this.getTokenValue()
    );
  },
  removeWarehouse: async function (id) {
    return await this.deleteApi(
      apiUrl.removeWarehouse + id,
      this.getTokenValue()
    );
  },
  getWarehouseTypes: async function () {
    return await this.getApi(apiUrl.getWarehouseTypes, this.getTokenValue());
  },
  findProductForWarehouse: async function (restaurantId, warehouseId, title) {
    return await this.getApi(
      apiUrl.findProductForWarehouse +
        "?restaurantId=" +
        restaurantId +
        "&warehouseId=" +
        warehouseId +
        "&title=" +
        title,
      this.getTokenValue()
    );
  },
  createWarehouseProduct: async function (request) {
    return await this.postApi(
      apiUrl.createWarehouseProduct,
      request,
      this.getTokenValue()
    );
  },
  createBulkyWarehouseProduct: async function (request) {
    return await this.postApi(
      apiUrl.createBulkyWarehouseProduct,
      request,
      this.getTokenValue()
    );
  },
  getWarehouseProducts: async function (
    warehouseId,
    productTitle,
    code,
    size,
    part
  ) {
    return await this.getApi(
      apiUrl.getWarehouseProducts +
        "?warehouseId=" +
        warehouseId +
        "&ProductTitle=" +
        productTitle +
        "&code=" +
        code +
        "&size=" +
        size +
        "&part=" +
        part,
      this.getTokenValue()
    );
  },
  getWarehouseProductInfo: async function (id) {
    return await this.getApi(
      apiUrl.getWarehouseProductInfo + "?Id=" + id,
      this.getTokenValue()
    );
  },
  removeWarehouseProduct: async function (id) {
    return await this.deleteApi(
      apiUrl.removeWarehouseProduct + id,
      this.getTokenValue()
    );
  },
  setItemsDiscount: async function (request) {
    return await this.postApi(
      apiUrl.setItemsDiscount,
      request,
      this.getTokenValue()
    );
  },
  createSupplier: async function (request) {
    return await this.postApi(
      apiUrl.createSupplier,
      request,
      this.getTokenValue()
    );
  },
  getSuppliers: async function (restaurantId, title, size, part) {
    return await this.getApi(
      apiUrl.getSuppliers +
        "?restaurantId=" +
        restaurantId +
        "&title=" +
        title +
        "&size=" +
        size +
        "&part=" +
        part,
      this.getTokenValue()
    );
  },
  getSupplierInfo: async function (id) {
    return await this.getApi(
      apiUrl.getSupplierInfo + "?Id=" + id,
      this.getTokenValue()
    );
  },
  removeSupplier: async function (id) {
    return await this.deleteApi(
      apiUrl.removeSupplier + id,
      this.getTokenValue()
    );
  },
  findProductForSupplier: async function (
    restaurantId,
    supplierId,
    title,
    size,
    part
  ) {
    return await this.getApi(
      apiUrl.findProductForSupplier +
        "?restaurantId=" +
        restaurantId +
        "&supplierId=" +
        supplierId +
        "&title=" +
        title +
        "&size=" +
        size +
        "&part=" +
        part,
      this.getTokenValue()
    );
  },
  getSupplierProducts: async function (SupplierId, ProductTitle, size, part) {
    return await this.getApi(
      apiUrl.getSupplierProducts +
        "?SupplierId=" +
        SupplierId +
        "&ProductTitle=" +
        ProductTitle +
        "&size=" +
        size +
        "&part=" +
        part,
      this.getTokenValue()
    );
  },
  createSupplierProduct: async function (request) {
    return await this.postApi(
      apiUrl.createSupplierProduct,
      request,
      this.getTokenValue()
    );
  },
  createBulkySupplierProduct: async function (request) {
    return await this.postApi(
      apiUrl.createBulkySupplierProduct,
      request,
      this.getTokenValue()
    );
  },
  removeSupplierProduct: async function (id) {
    return await this.deleteApi(
      apiUrl.removeSupplierProduct + id,
      this.getTokenValue()
    );
  },
  getPurchaseOrders: async function (
    restaurantId,
    title,
    purchaseOrderStatus,
    startDate,
    endDate,
    size,
    part
  ) {
    return await this.getApi(
      apiUrl.getPurchaseOrders +
        "?restaurantId=" +
        restaurantId +
        "&title=" +
        title +
        "&purchaseOrderStatus=" +
        purchaseOrderStatus +
        "&startDate=" +
        startDate +
        "&endDate=" +
        endDate +
        "&size=" +
        size +
        "&part=" +
        part,
      this.getTokenValue()
    );
  },
  createPurchaseOrder: async function (request) {
    return await this.postApi(
      apiUrl.createPurchaseOrder,
      request,
      this.getTokenValue()
    );
  },
  getPurchaseOrderInfo: async function (id) {
    return await this.getApi(
      apiUrl.getPurchaseOrderInfo + "?Id=" + id,
      this.getTokenValue()
    );
  },
  removePurchaseOrder: async function (id) {
    return await this.deleteApi(
      apiUrl.removePurchaseOrder + id,
      this.getTokenValue()
    );
  },
  findProductForOrder: async function (
    restaurantId,
    purchaseOrderId,
    title,
    code,
    size,
    part
  ) {
    return await this.getApi(
      apiUrl.findProductForOrder +
        "?restaurantId=" +
        restaurantId +
        "&purchaseOrderId=" +
        purchaseOrderId +
        "&title=" +
        title +
        "&code=" +
        code +
        "&size=" +
        size +
        "&part=" +
        part,
      this.getTokenValue()
    );
  },
  getProductInfoForPurchase: async function (id) {
    return await this.getApi(
      apiUrl.getProductInfoForPurchase + "?productId=" + id,
      this.getTokenValue()
    );
  },
  getPurchaseOrderItems: async function (
    purchaseOrderId,
    productName,
    code,
    size,
    part
  ) {
    return await this.getApi(
      apiUrl.getPurchaseOrderItems +
        "?purchaseOrderId=" +
        purchaseOrderId +
        "&productName=" +
        productName +
        "&code=" +
        code +
        "&size=" +
        size +
        "&part=" +
        part,
      this.getTokenValue()
    );
  },
  createPurchaseOrderItem: async function (request) {
    return await this.postApi(
      apiUrl.createPurchaseOrderItem,
      request,
      this.getTokenValue()
    );
  },
  getPurchaseOrderItemInfo: async function (id) {
    return await this.getApi(
      apiUrl.getPurchaseOrderItemInfo + "?Id=" + id,
      this.getTokenValue()
    );
  },
  removePurchaseOrderItem: async function (id) {
    return await this.deleteApi(
      apiUrl.removePurchaseOrderItem + id,
      this.getTokenValue()
    );
  },
};
export default apiMethod;
